<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialogMedia" width="80%" transition="dialog-bottom-transition">
      <v-card ref="dialog">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer />
          <div
            v-if="config.media && config.media.marker"
            class="toolbar"
            ref="markerActivator"
            id="markerActivator"
          >
            <v-btn @click="showApiMarker('myImage')">mark</v-btn>
          </div>
        </v-toolbar>
        <v-card-text>
          <img ref="myImage" :src="imgUrl" crossorigin width="100%" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
  }
}
</i18n>

<script>
import { mapGetters, mapActions } from "vuex";
import { api as confApi } from "@/store/modules/configuration";
import { api } from "@/store/modules/audit";

import { MarkerArea, ArrowMarker } from "markerjs";

export default {
  props: {
    items: {
      default: []
    },
    dialogMedia: {
      type: Boolean,
      default: false
    },
    context: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    currentMarkerArea: null,
    currentMedia: {},
    newUrl: null
  }),
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.finding]),
    config() {
      return this.finding || {};
    },
    imgUrl() {
      if (this.newUrl) {
        return this.newUrl;
      } else {
        return this.currentMedia.url;
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.updateFindingAttachment]),
    showApiMarker(img) {
      this.currentMarkerArea = new MarkerArea(this.$refs[img], {
        targetRoot: this.$refs["dialog"].$el,
        renderAtNaturalSize: true
      });
      //console.log("markerjs:markerarea", this.currentMarkerArea);
      //this.currentMarkerArea.open();
      this.$refs.markerActivator.style.display = "none";
      //this.$refs.markerControls.style.display = "";
      this.currentMarkerArea.show(
        dataUrl => {
          this.$store.dispatch("app/setLoading", true, { root: true });
          this.updateFindingAttachment({
            ref: { ...this.context.ref, mediaId: this.currentMedia.mediaId },
            data: { url: this.currentMedia.url, dataUrl }
          })
            .then(newUrl => {
              this.newUrl = newUrl;
              console.log("updateFindingAttachment", newUrl);
              this.$refs.markerActivator.style.display = "";
            })
            .catch(err => {
              console.error(err);
              alert("Mark image failed");
            })
            .finally(() => {
              this.$store.dispatch("app/setLoading", false, { root: true });
            });
        },
        () => {
          this.$refs.markerActivator.style.display = "";
        }
      );
    },
    addArrow() {
      if (this.currentMarkerArea) {
        console.log("markerjs:addmarker");
        this.currentMarkerArea.addMarker(ArrowMarker);
      }
    },
    deleteMarker() {
      if (this.currentMarkerArea) {
        this.currentMarkerArea.deleteActiveMarker();
      }
    },
    render() {
      console.log("markerjs:beforerender", this.currentMarkerArea);
      if (this.currentMarkerArea) {
        this.currentMarkerArea.render(dataUrl => {
          console.log("markerjs:render", dataUrl, this);
          // TODO: Durch das Setzen der URL als DataURL fliegt alles Auseinander
          //this.currentMedia.url = dataUrl;
        });
        this.closeMarkerArea();
      }
    },
    closeMarkerArea() {
      if (this.currentMarkerArea) {
        this.currentMarkerArea.close();
      }

      this.$refs.markerActivator.style.display = "";
      //this.$refs.markerControls.style.display = "none";
    },

    close() {
      this.$emit("update:dialogMedia", false);
    }
  },
  watch: {
    items(newVal) {
      this.newUrl = null;
      this.currentMedia = newVal[0];
    }
  },
  mounted() {
    this.currentMedia = this.items[0];
    //console.log("Markerjs:myimage", this.$refs.myimage);
    //const mark = new MarkerArea(document.getElementById("myimage"));
    /*mark.show(dataUrl => {
      const res = document.getElementById("myimage");
      res.src = dataUrl;
    });*/
  }
};
</script>
